<template>
    <section id="allowcookies" class="flex-column flex-lg-row justify-content-lg-between align-items-lg-center hide">
        <p class="txt mb-0">
            We use cookies to offer a better browsing experience, analyze site traffic, personalize
            content, and assist in our marketing efforts. Read more about our <a
                href="https://www.ironshorepharma.com/privacy.html" target="_blank">privacy policy</a>.
        </p>
        <div class="buttons">
            <a @click="acceptCookie" href="javascript:void(0);" class="button">Accept Cookies</a>
        </div>
        <div class="closeBtn">
            <a @click="acceptCookie" href="javascript:void(0);">
                <img src="@/assets/img/cookie-component/closeBtn.svg" alt="Close" />
            </a>
        </div>
    </section>
</template>
<script>
export default {
    mounted() {
        let isAccepted = (localStorage.getItem('journayhcpcookieacepted') === 'true') || false;
        let element = document.getElementById("allowcookies");
        if (!isAccepted) {
            element.classList.remove("hide");
        }
    },
    methods: {
        acceptCookie() {
            let element = document.getElementById("allowcookies");
            localStorage.setItem('journayhcpcookieacepted', 'true');
            element.classList.add("hide");
        },
        close() {
            let element = document.getElementById("allowcookies");
            element.classList.add("hide");
        }
    }

}
</script>